export const EMPTY_TAX_RATES = {
  fedLtRate: 0,
  fedStRate: 0,
  lossCap: 0,
  niitRate: 0,
  stateRate: 0,
};
